import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getItemChangesApi } from './getItemChanges.api'
import getItemChangesInitialState from './getItemChanges.initialState'
import { GetItemChangesErrorResponse, GetItemChangesRequestPayload } from './getItemChanges.types'

export const getItemChanges = createAsyncThunk(
  urls.items.changes,
  async (payload: GetItemChangesRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess, onError } = payload

    try {
      const response = await getItemChangesApi(request)

      onSuccess && onSuccess(response.data)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, onError, true)

      return rejectWithValue(error)
    }
  }
)

const getItemChangesSlice = createSlice({
  name: urls.items.changes,
  initialState: getItemChangesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getItemChanges.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getItemChanges.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getItemChanges.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetItemChangesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getItemChangesActions, reducer: getItemChangesReducer } = getItemChangesSlice
export default getItemChangesSlice.reducer
